import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import {Card,CardContent,} from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import { checkForUpdates, getApiCadVer, getApiVer } from 'reducers/AppInfoReducer';
import Button from '@material-ui/core/Button';
import { getWorkstationID } from 'reducers/ConfigReducer';
import { closeAbooutDialog } from 'reducers/DialogsReducer';
import projectLogo from 'assets/images/icon-ARC.png'; //'assets/images/icon-CAD.svg';//'../assets/images/hero-image.png';
import ptsLogo from 'assets/images/PTS-logo.png'; //'assets/images/logo.png';//

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const useStyles = makeStyles(() => ({
  content: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    textAlign: 'center',
    minHeight: 150,
  },
  card: {
    width: 480,
    background: 'fff',
    '& img': {
      width: '100%',
    },
  },

  branding: {
    width: '100%',
    height: 200,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    background: '#0051a0', //'#ce0000',
    '& img': {
      width: 150,
      height: 'auto',
    },
  },
  branding2: {
    width: '100%',
    textAlign: 'center',
    padding: '25px 0 5px',
    '& img': {
      height: 50,
      width: 'auto',
    },
  },
  actions: {
    textAlign: 'center',
    marginTop: 30,
    '& button': {
      background: '#0153a3',
      paddingLeft: '4em',
      paddingRight: '4em',
      textTransform: 'uppercase',
      '&:hover': {
        background: '#0000a8',
      },
    },
    '& button.Mui-disabled': {
      color: 'rgba(0, 0, 0, 0.26)',
      backgroundColor: 'rgba(0, 0, 0, 0.12)',
    },
  },
  footer: {
    fontSize: 13,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'end',
    '& p': {
      marginBottom: 0,
    },
  },
  action: {
    marginBottom: 10,
  },
}));

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

function AboutDialog(props) {
  const classes = useStyles();
  const {
    apiVersion,
    availBuildNo,
    availBuildTime,
    buildNo,
    buildTime,
    appVersion,
  } = props.appInfo;
  const updateAvail = buildNo !== availBuildNo || buildTime !== availBuildTime;
  const workstationID = getWorkstationID();
  const year = new Date().getFullYear();

  useEffect(() => {
    props.getApiVer();
    props.getApiCadVer();
    props.checkForUpdates();
    // eslint-disable-next-line
  }, []);

  const reload = () => {
    window.location.reload(true);
  };

  return (
    <Dialog onClose={props.closeAbooutDialog} open={true}>
      <DialogContent dividers className='p-0'>
        <Card className={classes.card}>
          <div className={classes.branding}>
            <img src={projectLogo} alt="MOBILE icon" />
          </div>
          <div className={classes.branding2}>
            <img src={ptsLogo} alt="PTS logo" />
          </div>
          <CardContent>
          <div className={classes.content}>
            <div className={classes.header}>
              <p>
                <strong>PTS Archive Browser</strong>
              </p>
            </div>
            <div className={classes.body}>
              <p>
                App version: {appVersion} <br />
                Api version: {apiVersion} <br />
                Build no: {buildNo} <br />
                Build date: {buildTime} <br />
                Workstation ID: {workstationID}
                <br />
                {updateAvail && <span>(update available)</span>}
                {!updateAvail && <span>(up to date)</span>}
              </p>
              {updateAvail && (
                <div className={classes.action}>
                  <Button size="small" variant="outlined" className={classes.margin} onClick={reload}>
                    Reload
                  </Button>
                </div>
              )}
            <div className={classes.actions} >
              <Button  variant="contained" size="large" className="my-2" style={{color: '#fff'}} onClick={props.closeAbooutDialog}>
                Close
              </Button>
            </div>
            </div>
            <div className={classes.footer}>
              <p>
                &copy; {year} <a style={{color: '#0153a3'}} href="https://ptssolutions.com">ptssolutions.com</a>, All Rights
                Reserved
              </p>
            </div>
          </div>
          </CardContent>
        </Card>     
      </DialogContent>
    </Dialog>
  );
}

const mapStateToProps = (state) => {
  return {
    appInfo: state.appInfo,
    config: state.config,
  };
};

export default connect(mapStateToProps, {
  checkForUpdates,
  getApiCadVer,
  getApiVer,
  closeAbooutDialog,
})(AboutDialog);
